import { SiafLiteApiRepository, SiafLiteApiStream } from "../../external";
import store from "../../config/store";

class NfSaidaService {
  constructor() {
    this.urlBase = "faturamento/nf-saida";
    this.urlBaseEvent = `/event/${this.urlBase}`;
    this.urlBaseCompleta = `${store.baseUrl}/${this.urlBase}`;
  }

  getAll(filter) {
    return new SiafLiteApiRepository(this.urlBaseEvent).get(filter);
  }

  getAllFiltroAvancado(body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).patch(body);
  }

  getById(id) {
    return new SiafLiteApiRepository(this.urlBaseEvent).getById(id);
  }

  getVinculoOperacaoFiscal(operacaoFiscalId) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/${operacaoFiscalId}/vinculo-operacao-fiscal`
    ).get();
  }

  cadastrar(body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).post(body);
  }

  atualizar(id, body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).put(id, body);
  }

  deletar(id) {
    return new SiafLiteApiRepository(this.urlBaseEvent).delete(id);
  }

  getResumoSaidasTotais() {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/estatistica/resumo-saidas-totais`
    ).get();
  }

  getVendasPorMes(filtros) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/estatistica/resumo-saidas-mes`
    ).patch(filtros);
  }

  getVendasPorHora() {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/estatistica/resumo-saidas-hora`
    ).get();
  }

  getVendas() {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/estatistica/resumo-saidas`
    ).get();
  }

  getAllAutoSequencia(query) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/autoSequencia/lista`
    ).get(query);
  }

  getRelatorioResumido(body) {
    return new SiafLiteApiStream(
      `${this.urlBaseCompleta}/relatorios/resumido`
    ).path(body);
  }

  getRelatorioDetalhado(body) {
    return new SiafLiteApiStream(
      `${this.urlBaseCompleta}/relatorios/detalhado`
    ).path(body);
  }

  getRelatorioDesvioPreco(body) {
    return new SiafLiteApiStream(
      `${this.urlBaseCompleta}/relatorios/desvio-preco`
    ).path(body);
  }

  getRelatorioDashboardFaturamento(body) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/relatorios/dashboard-faturamento`
    ).patch(body);
  }

  getRelatorioDashboardQtdVendas(body) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/relatorios/dashboard-qtd-vendas`
    ).patch(body);
  }

  getRelatorioDashboardTicketMedio(body) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/relatorios/dashboard-ticket-medio`
    ).patch(body);
  }

  getRelatorioDashboardVendasPorMeioPagamento(body) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/relatorios/dashboard-vendas-meio-pagamento`
    ).patch(body);
  }

  getRelatorioDashboardProdutosVendidos(body) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/relatorios/dashboard-produtos-vendidos`
    ).patch(body);
  }

  getRelatorioDashboardClientesFaturamento(body) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/relatorios/dashboard-clientes-faturamento`
    ).patch(body);
  }

  getRelatorioResumidoContador(body) {
    return new SiafLiteApiStream(
      `${this.urlBaseCompleta}/relatorios/resumido-contador`
    ).path(body);
  }

  getRelatorioComissaoVendedores(body) {
    return new SiafLiteApiStream(
      `${this.urlBaseCompleta}/relatorios/comissao-vendedores`
    ).path(body);
  }

  getRelatorioVendasVendedor(body) {
    return new SiafLiteApiStream(
      `${this.urlBaseCompleta}/relatorios/vendas-vendedores`
    ).path(body);
  }

  getRelatorioItensCancelados(body) {
    return new SiafLiteApiStream(
      `${this.urlBaseCompleta}/relatorios/itens-cancelados`
    ).path(body);
  }

  getRelatorioAnaliseAbcProdutos(body) {
    return new SiafLiteApiStream(
      `${this.urlBaseCompleta}/relatorios/analise-abc-produtos`
    ).path(body);
  }

  getRelatorioVendasCliente(body) {
    return new SiafLiteApiStream(
      `${this.urlBaseCompleta}/relatorios/vendas-cliente`
    ).path(body);
  }

  cancelar(id, body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).put(
      id,
      body,
      "nota-fiscal/cancelamento"
    );
  }

  getDanfe(id) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/${id}/nota-fiscal/xml/danfe`
    ).get();
  }

  getCartaCorrecao(id) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/${id}/nota-fiscal/xml/carta-correcao`
    ).get();
  }

  getDanfeSecundaria(id, empresa) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/${id}/nfce-secundaria`
    ).patch({ empresa });
  }

  getDanfeContingencia(id, empresa) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/${id}/nfce-contingencia`
    ).patch({ empresa });
  }

  getDadosXml(id) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/${id}/nota-fiscal/xml/dados`
    ).get();
  }

  getArquivoXml(id) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/${id}/nota-fiscal/xml/arquivo`
    ).get();
  }

  emitirNotaFiscal(id) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/${id}/nota-fiscal/emitir`
    ).get();
  }

  emitirNotaFiscalLote(body) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/nota-fiscal/emitir-lote`
    ).patch(body);
  }

  emitirNotaFiscalPendenciaContingencia(id) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/${id}/nota-fiscal/emitir-pendencia-contingencia`
    ).get();
  }

  validarNotaFiscal(id) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/${id}/nota-fiscal/valida`
    ).get();
  }

  cartaCorrecao(id, body) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/${id}/nota-fiscal/carta-correcao`
    ).post(body);
  }

  setCodigoManual(body) {
    return new SiafLiteApiRepository(`${this.urlBaseEvent}/autoSequencia`).post(
      body
    );
  }

  consultarStatusNotaFiscal(id) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/${id}/nota-fiscal/consulta-status`
    ).get();
  }

  enviarNotaFiscalContigencia(id) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/${id}/nota-fiscal/envia-contigencia`
    ).get();
  }

  inutilizacaoDfe(sequencia) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/inutilizar-dfe`
    ).post(sequencia);
  }
}

export default NfSaidaService;
